import { WITHOUT_INCOME, WITH_INCOME } from 'utils/enums/misc';
import {
  ApplicationData,
  EventRecipient,
  FileDetails,
  ValidationObj,
  ValidationSet
} from '../../../../../types/interface';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import StandardSelect from 'base/StandardSelect/StandardSelect';
import { t } from 'i18next';
import StandardInput from 'base/StandardInput/StandardInput';
import { StandardCurrency } from 'base/StandardCurrency/StandardCurrency';
import {
  capitalizeFirstLetter,
  convertDateFormat,
  convertToCurrency,
  formatDateOnly,
  isFieldEmptyAndInOverview,
  parseIntoNumber
} from 'utils/helpers';
import { StandardImageUpload } from 'base/StandardImageUpload/StandardImageUpload';

export const EducationApplication = ({
  data
}: {
  data: ApplicationData;
  basic_data: typeof WITHOUT_INCOME | typeof WITH_INCOME;
}) => {
  const disabled = true;
  const showError = false;
  const handleOnChange = (a: number, b: keyof EventRecipient, c: any) => {};
  const EducationApplicationValidationSet: ValidationSet<EventRecipient> = {
    child: [],
    organizer: [],
    event_name: [],
    selected_event_name: [],
    child_name: [],
    event: [],
    confirmation_of_participation: [],
    confirmation_of_participation_date_proof: [],
    payment_confirmation: [],
    payment_confirmation_date_proof: [],
    invoice: [],
    invoice_date_proof: [],
    refund_percentage: [],
    refunded_amount: [],
    filled_out_template: [],
    filled_out_template_date_proof: [],
    filled_out_template_amount: [],
    invoice_amount: [],
    event_end_date: [],
    event_start_date: [],
    support_provided: []
  };
  return (
    <div>
      <div className="row my-3">
        <div className="col-12">
          <h1 className="text-center my-2 fs-40">
            {capitalizeFirstLetter(t('applications.application_type.text_2'))}
          </h1>
        </div>
      </div>
      {data?.events?.map((application, index: number) => {
        return (
          <div className="col-12" key={`health-application-${index}`}>
            <ConditionalRender condition={index > 0}>
              <div className="d-flex gap-4 align-items-center">
                <div className="w-100">
                  <hr />
                </div>
              </div>
            </ConditionalRender>
            <div className="row">
              <div className="col-12 col-lg-2">
                <StandardSelect
                  value={application.child ? Number(application.child) : null}
                  placeholder={t('application.education.placeholder.text_7')}
                  onChange={() => {}}
                  className={isFieldEmptyAndInOverview(
                    true,
                    !!application.child
                  )}
                  disabled={disabled}
                  options={[
                    {
                      value: Number(application.child),
                      label: application.child_name
                    }
                  ]}
                  showError={showError}
                  validations={EducationApplicationValidationSet.child}
                  label={t('application.education.placeholder.text_7')}
                  formClassName=""
                  id=""
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className={' col-12 col-lg-2'}>
                <StandardInput
                  placeholder={t('general.input_fields.text_30')}
                  disabled={disabled}
                  value={application.organizer}
                  onChange={e => {
                    handleOnChange(index, 'organizer', e);
                  }}
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.organizer
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  showError={showError}
                  validations={EducationApplicationValidationSet.organizer}
                  label={t('general.input_fields.text_30')}
                  type="text"
                />
              </div>
              <div className={'form-control-icon col-12 col-lg-2'}>
                <StandardInput
                  placeholder={t('event.table.title_2')}
                  value={application.event_name}
                  disabled={disabled}
                  onChange={e => {}}
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.event_name
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  showError={showError}
                  validations={EducationApplicationValidationSet.event_name}
                  label={t('event.table.title_2')}
                  type="text"
                />
              </div>
              <div className="col-12 col-lg-2">
                <StandardSelect
                  value={application.event ? Number(application.event) : null}
                  disabled={disabled}
                  placeholder={t('application.education.placeholder.text_6')}
                  onChange={() => {}}
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.event
                  )}`}
                  options={[
                    {
                      value: Number(application.event),
                      label: application.selected_event_name
                    }
                  ]}
                  showError={showError}
                  validations={EducationApplicationValidationSet.event}
                  label={t('application.education.placeholder.text_6')}
                  formClassName=""
                  id=""
                  formGroupClassName="d-flex flex-column justify-content-between pb-1 h-100"
                />
              </div>
              <div className="form-control-icon col-12 col-lg-2 col-md-6">
                <StandardInput
                  placeholder={t('application.education.placeholder.text_10')}
                  value={formatDateOnly(application.event_start_date as Date)}
                  disabled={disabled}
                  onChange={e => {
                    handleOnChange(index, 'event_start_date', e as string);
                  }}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.event_start_date
                  }
                  label={t('application.education.placeholder.text_10')}
                  type="text"
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.event_start_date
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                />
              </div>
              <div className="form-control-icon col-12 col-lg-2 col-md-6">
                <StandardInput
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.event_end_date
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  placeholder={t('application.education.placeholder.text_11')}
                  value={formatDateOnly(application.event_end_date as Date)}
                  disabled={disabled}
                  onChange={e => {
                    handleOnChange(index, 'event_end_date', e as string);
                  }}
                  showError={showError}
                  validations={EducationApplicationValidationSet.event_end_date}
                  label={t('application.education.placeholder.text_11')}
                  type="text"
                />
              </div>
            </div>

            <div className="row my-2">
              <div className="col-12 font-bold">
                {t('application.education.general.text_3')}
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-2 col-md-6">
                <StandardImageUpload
                  className={isFieldEmptyAndInOverview(
                    true,
                    !!application.filled_out_template
                  )}
                  value={application.filled_out_template as FileDetails}
                  disabled={!disabled}
                  imageText={t('application.education.placeholder.text_12')}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.filled_out_template
                  }
                />
              </div>
              <div className="col-12 col-lg-2 col-md-6">
                <StandardCurrency
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.filled_out_template_amount
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  onChange={e => {
                    handleOnChange(
                      index,
                      'filled_out_template_amount',
                      parseIntoNumber(e)
                    );
                  }}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.filled_out_template_amount as ValidationObj[]
                  }
                  label={t('application.education.placeholder.text_13')}
                  placeholder={t('application.education.placeholder.text_13')}
                  value={parseIntoNumber(
                    application.filled_out_template_amount
                  )}
                  disabled={disabled}
                />
              </div>
              <div className="col-12 col-lg-2 col-md-6">
                <StandardInput
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.filled_out_template_date_proof
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  placeholder={t('basic_data.with_income.placeholder.text_4')}
                  value={formatDateOnly(
                    application.filled_out_template_date_proof as Date
                  )}
                  disabled={disabled}
                  onChange={e => {
                    handleOnChange(
                      index,
                      'filled_out_template_date_proof',
                      e as string
                    );
                  }}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.filled_out_template_date_proof as ValidationObj[]
                  }
                  label={t('basic_data.with_income.placeholder.text_4')}
                  type="text"
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col-12">
                {t('application.education.general.text_5')}
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-4 col-md-6">
                <StandardImageUpload
                  className={isFieldEmptyAndInOverview(
                    true,
                    !!application.confirmation_of_participation
                  )}
                  value={
                    application.confirmation_of_participation as FileDetails
                  }
                  disabled={!disabled}
                  imageText={t('application.education.attachment.text_1')}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.confirmation_of_participation
                  }
                />
              </div>
              <div className="col-12 col-lg-2 col-md-6">
                <StandardInput
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.confirmation_of_participation_date_proof
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  placeholder={t('basic_data.with_income.placeholder.text_4')}
                  value={formatDateOnly(
                    application.confirmation_of_participation_date_proof as Date
                  )}
                  disabled={disabled}
                  onChange={e => {
                    handleOnChange(
                      index,
                      'confirmation_of_participation_date_proof',
                      e as string
                    );
                  }}
                  showError={
                    application.filled_out_template ? false : showError
                  }
                  validations={
                    EducationApplicationValidationSet.confirmation_of_participation_date_proof as ValidationObj[]
                  }
                  label={t('basic_data.with_income.placeholder.text_4')}
                  type="text"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-2 col-md-6">
                <StandardImageUpload
                  className={isFieldEmptyAndInOverview(
                    true,
                    !!application.invoice
                  )}
                  disabled={!disabled}
                  value={application.invoice as FileDetails}
                  imageText={t('application.education.attachment.text_4')}
                  showError={false}
                  validations={EducationApplicationValidationSet.invoice}
                />
              </div>
              <div className="col-12 col-lg-2 col-md-6">
                <StandardCurrency
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.invoice_amount
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  onChange={e => {
                    handleOnChange(index, 'invoice_amount', e);
                  }}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.invoice_amount as ValidationObj[]
                  }
                  label={t('application.education.placeholder.text_14')}
                  placeholder={t('application.education.placeholder.text_14')}
                  value={parseIntoNumber(application.invoice_amount)}
                  disabled={disabled}
                />
              </div>
              <div className="col-12 col-lg-2 col-md-6">
                <StandardInput
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.invoice_date_proof
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  placeholder={t('basic_data.with_income.placeholder.text_4')}
                  disabled={disabled}
                  value={formatDateOnly(application.invoice_date_proof as Date)}
                  onChange={e => {
                    handleOnChange(index, 'invoice_date_proof', e as string);
                  }}
                  showError={!application.invoice ? false : showError}
                  validations={
                    EducationApplicationValidationSet.invoice_date_proof as ValidationObj[]
                  }
                  label={t('basic_data.with_income.placeholder.text_4')}
                  type="text"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-2 col-md-6">
                <StandardImageUpload
                  className={isFieldEmptyAndInOverview(
                    true,
                    !!application.payment_confirmation
                  )}
                  value={application.payment_confirmation as FileDetails}
                  disabled={!disabled}
                  imageText={t('application.general.text_27')}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.payment_confirmation as ValidationObj[]
                  }
                />
              </div>
              <div className="col-12 col-lg-2 col-md-6">
                <StandardCurrency
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.payment_confirmation_amount
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  onChange={e => {
                    handleOnChange(index, 'payment_confirmation_amount', e);
                  }}
                  showError={showError}
                  validations={
                    EducationApplicationValidationSet.payment_confirmation_amount as ValidationObj[]
                  }
                  label={t('application.education.placeholder.text_15')}
                  placeholder={t('application.education.placeholder.text_15')}
                  value={parseIntoNumber(
                    application.payment_confirmation_amount
                  )}
                  disabled={disabled}
                />
              </div>
              <div className="col-12 col-lg-2 col-md-6">
                <StandardInput
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!application.payment_confirmation_date_proof
                  )} d-flex flex-column justify-content-between pb-1 h-100`}
                  placeholder={t('basic_data.with_income.placeholder.text_4')}
                  disabled={disabled}
                  value={formatDateOnly(
                    application.payment_confirmation_date_proof as Date
                  )}
                  onChange={e => {
                    handleOnChange(
                      index,
                      'payment_confirmation_date_proof',
                      e as string
                    );
                  }}
                  showError={
                    application.filled_out_template ? false : showError
                  }
                  validations={
                    EducationApplicationValidationSet.payment_confirmation_date_proof as ValidationObj[]
                  }
                  label={t('basic_data.with_income.placeholder.text_4')}
                  type="text"
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
